module.exports = __webpack_public_path__ + "static/media/yammer-icon.50373c4d.svg";